<article class="container">
  <div class="row">
    @if (allMedia().length) {
      <div
        class="col-sm-6 col-md-4 order-2 d-flex align-items-center"
        [class.mt-md-10]="block().text && allMedia().length >= 3"
        [class.col-md-6]="allMedia().length === 1"
      >
        <!--<img
          class=""
          [attr.data-object-position]="block().image?.anchor"
          [src]="block().gallery?.[0]?.absoluteUrl || '' | resize: 900 : 1125 : 'topleft' : 'crop' : 'webp'"
          [alt]="block().gallery?.[0]?.caption || block().gallery?.[0]?.absoluteUrl"
        />-->

        @let media = allMedia()[0];
        @let img = getMediaItem(media);
        @let items = getMediaPoints(media);
        <figure class="media">
          <img
            [ngSrc]="img?.absoluteUrl || ''"
            [width]="800"
            [height]="1000"
            ngSrcset="550w, 800w, 1200w, 1600w, 1920w"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            [attr.data-object-position]="img?.anchor || 'middlecenter'"
            [loaderParams]="{
              anchor: img?.anchor || 'middlecenter',
              mode: 'crop',
              format: 'webp',
              width: 800,
              height: 1000,
            }"
            [alt]="img?.altText || img?.caption || img?.absoluteUrl"
            #imgElement
          />
          @if (items.length) {
            <app-media-point-map
              class="media__overlay"
              [points]="items"
              [connectedElement]="imgElement"
              [hostIsConnnected]="true"
            ></app-media-point-map>
          }
        </figure>
      </div>
    }
    <div
      class="col-sm-6 col-md-4 content-block-with-images__text"
      [ngClass]="allMedia().length !== 3 ? 'mt-3 mt-md-0' : ''"
      [class.order-3]="block().textAlignment !== 'left' && (allMedia().length || 0) === 2"
      [class.order-md-2]="allMedia().length === 3"
      [class.order-1]="block().textAlignment === 'left'"
      [class.justify-content-center]="allMedia().length !== 1"
      [class.pt-4]="allMedia().length === 1"
    >
      @if (allMedia().length === 3) {
        <!--<img
          class="aspect-ratio-square mt-3 mt-sm-0"
          [attr.data-object-position]="block().image?.anchor"
          [src]="img?.absoluteUrl || '' | resize: 900 : 900 : 'topleft' : 'crop' : 'webp'"
          [alt]="img?.caption || img?.absoluteUrl"
        />-->

        @let media = allMedia()[1];
        @let img = getMediaItem(media);
        @let items = getMediaPoints(media);

        <figure class="media">
          <img
            class="aspect-ratio-square mt-3 mt-sm-0"
            [ngSrc]="img?.absoluteUrl || ''"
            [width]="900"
            [height]="900"
            ngSrcset="550w, 800w, 1200w, 1600w, 1920w"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            [attr.data-object-position]="block().image?.anchor || 'middlecenter'"
            [loaderParams]="{
              anchor: block().image?.anchor || 'middlecenter',
              mode: 'crop',
              format: 'webp',
              width: 900,
              height: 900,
            }"
            [alt]="img?.altText || img?.caption || img?.absoluteUrl"
            #imgElement1
          />
          @if (items.length) {
            <app-media-point-map
              class="media__overlay"
              [points]="items"
              [connectedElement]="imgElement1"
              [hostIsConnnected]="true"
            ></app-media-point-map>
          }
        </figure>
      }

      @if (block().title && allMedia().length !== 3) {
        <h2 class="h1">{{ block().title }}</h2>
      }

      @if (block().text) {
        <div
          class="markdown-content"
          [class.mt-3]="allMedia().length === 3"
          [innerHTML]="block().text | stripEmbed: cookies() ?? undefined | safe"
          fstrDynamicContent
        ></div>
      }

      @if (block().button && allMedia().length !== 3) {
        @if (block().button?.routerLink?.length) {
          <a class="button button--secondary" [routerLink]="block().button?.routerLink">
            {{ block().button?.text || ('standaard-knoptekst' | fromDictionary) }}
          </a>
        }
        @if (!block().button?.routerLink?.length) {
          <a class="button button--secondary" [href]="block().button?.url">
            {{ block().button?.text || ('standaard-knoptekst' | fromDictionary) }}
          </a>
        }
      }
    </div>
    @if ((allMedia().length || 0) > 1) {
      <div
        class="col-sm-6 col-md-4 d-flex order-2 align-items-center"
        [ngClass]="block().text && allMedia().length === 3 ? 'mt-md-10 mt-2' : ''"
      >
        @if (allMedia().length === 3) {
          <!--<img
            class=""
            [ngClass]="!(block().text || block().title || block().text) ? 'mt-3 mt-sm-0' : ''"
            [attr.data-object-position]="block().image?.anchor"
            [src]="block().gallery?.[2]?.absoluteUrl || '' | resize: 900 : 1125 : 'topleft' : 'crop' : 'webp'"
            [alt]="block().gallery?.[2]?.caption || block().gallery?.[2]?.absoluteUrl"
          />-->

          @let media = allMedia()[2];
          @let img = getMediaItem(media);
          @let items = getMediaPoints(media);

          <figure class="media">
            <img
              [ngClass]="!(block().text || block().title || block().text) ? 'mt-3 mt-sm-0' : ''"
              [ngSrc]="img?.absoluteUrl || ''"
              [width]="900"
              [height]="1125"
              ngSrcset="550w, 800w, 1200w, 1600w, 1920w"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              [attr.data-object-position]="img?.anchor || 'middlecenter'"
              [loaderParams]="{
                anchor: img?.anchor || 'middlecenter',
                mode: 'crop',
                format: 'webp',
                width: 900,
                height: 1125,
              }"
              [alt]="img?.altText || img?.caption || img?.absoluteUrl"
              #imgElement2
            />
            @if (items.length) {
              <app-media-point-map
                class="media__overlay"
                [points]="items"
                [connectedElement]="imgElement2"
                [hostIsConnnected]="true"
              ></app-media-point-map>
            }
          </figure>
        }
        @if (allMedia().length !== 3) {
          <!--<img
            class="mt-3 mt-sm-0"
            [attr.data-object-position]="block().image?.anchor"
            [src]="img?.absoluteUrl || '' | resize: 900 : 1125 : 'topleft' : 'crop' : 'webp'"
            [alt]="img?.caption || img?.absoluteUrl"
          />-->

          @let media = allMedia()[1];
          @let img = getMediaItem(media);
          @let items = getMediaPoints(media);

          <figure class="media">
            <img
              class="mt-3 mt-sm-0"
              [ngSrc]="img?.absoluteUrl || ''"
              [width]="900"
              [height]="1125"
              ngSrcset="550w, 800w, 1200w, 1600w, 1920w"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              [attr.data-object-position]="img?.anchor || 'middlecenter'"
              [loaderParams]="{
                anchor: img?.anchor || 'middlecenter',
                mode: 'crop',
                format: 'webp',
                width: 900,
                height: 1125,
              }"
              [alt]="img?.altText || img?.caption || img?.absoluteUrl"
              #imgElement3
            />

            @if (items.length) {
              <app-media-point-map
                class="media__overlay"
                [points]="items"
                [connectedElement]="imgElement3"
                [hostIsConnnected]="true"
              ></app-media-point-map>
            }
          </figure>
        }
      </div>
    }
  </div>
</article>
